// Zoom for the artifact panes (#11548 r74): the documents viewer's ladder
// (useDocumentZoom) without its file-type gate — every artifact pane is
// zoomable. Content scales via CSS `zoom` on a wrapper, with the controls
// kept outside the wrapper so they hold their size.
import { useState } from "react";

const ZOOM_LEVELS = [50, 75, 90, 100, 110, 125, 150, 175, 200];

const DEFAULT_ZOOM = 100;

export const usePaneZoom = (): {
  zoomLevel: number;
  zoomIn: () => void;
  zoomOut: () => void;
  resetZoom: () => void;
} => {
  const [zoomLevel, setZoomLevel] = useState(DEFAULT_ZOOM);
  const zoomIn = () =>
    setZoomLevel((prev) => {
      const idx = ZOOM_LEVELS.findIndex((l) => l >= prev);
      return idx < ZOOM_LEVELS.length - 1 ? ZOOM_LEVELS[idx + 1] : prev;
    });
  const zoomOut = () =>
    setZoomLevel((prev) => {
      const idx = ZOOM_LEVELS.findIndex((l) => l >= prev);
      return idx > 0 ? ZOOM_LEVELS[idx - 1] : prev;
    });
  return {
    zoomLevel,
    zoomIn,
    zoomOut,
    resetZoom: () => setZoomLevel(DEFAULT_ZOOM),
  };
};
